import translations from '../../../translations';
import ButtonPrimary from '../../buttons/ButtonPrimary';
import FileDrop from '../../generic/upload/FileDrop';
import Loader from '../../loader/Loader';
import './css/import.css';

type ImportFlowFormProps = {
    isProcessing: boolean;
    importToken: string | null;
    onDrop: (files: File[]) => void;
    onChangeImportToken: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onImportToken: () => void;
};

const ImportFlowForm = ({
    isProcessing,
    importToken,
    onDrop,
    onChangeImportToken,
    onImportToken,
}: ImportFlowFormProps) => {
    return (
        <div className="import-flow">
            {isProcessing && <Loader message={translations.COMMON_processing} />}
            <FileDrop
                onChange={onDrop}
                placeholder={translations.IMPORT_EXPORT_file_drop_placeholder}
                fileTypes=".package,.package2"
            />
            <p>{translations.IMPORT_EXPORT_sharing_token_input_description}</p>
            <div className="shared-token-input">
                <input
                    type="text"
                    className="form-control import-token"
                    onChange={onChangeImportToken}
                    placeholder={translations.IMPORT_EXPORT_shared_token_input_placeholder}
                    value={importToken || ''}
                />
                <ButtonPrimary disabled={!importToken} onClick={() => onImportToken()}>
                    {translations.IMPORT_EXPORT_import_button_label}
                </ButtonPrimary>
            </div>
        </div>
    );
};

export default ImportFlowForm;
